import Vue from 'vue'
import App from './App'
import VueMeta from 'vue-meta'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vuelidate from 'vuelidate'
import store from './store/store'
import router from './router'
import { sync } from 'vuex-router-sync'
import VJstree from 'vue-jstree'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Vuelidate)
Vue.use(ElementUI, { locale })
Vue.use(VueMeta)
Vue.component('v-jstree', VJstree)

sync(store, router)

new Vue({
    render: (h) => h(App),
    router,
    store,
}).$mount('#app')
